import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { currencyFormatter } from "utils/currencyHelper";
import "containers/Navigation/styles.scss";
import { withNamespaces } from "react-i18next";
import { isEmpty } from "lodash";
import * as queryString from "query-string";
import { UserProfileIcon } from "component/icons";
import { SearchIcon } from "component/icons";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.setSearchVisibility = this._setSearchVisibility.bind(this);

    this.state = {
      searchClass: "col-7",
    };
  }

  _setSearchVisibility = () => {
    let search = queryString.parse(this.props.location.search);
    search.q = "";
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      search
    )}`;
    this.props.setSearchVisibility(!this.props.showSearch);
    this.props.navigateTo(newLoc);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.q !== nextProps.q && nextProps.q) {
    }
  }

  render() {
    const {
      t,
      isMobile,
      balance,
      showMenu,
      filtersVisible,
      page,
      showBanner,
      isSingleCategory,
    } = this.props;
    const isSearchToggled = !this.props.displaySearch && this.props.page;
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    return (
      <div
        className={`navigation container-fluid
        ${showMenu ? "with-menu" : ""}
        ${filtersVisible ? "filter-visible" : ""}
        ${showBanner && !isSingleCategory ? "show-banner" : ""}
        ${!isMobile ? "navigation-desktop" : ""}`}
      >
        <div className="row">
          {filtersVisible && !isMobile && <div className="nav-spacer" />}
          <div className="col col-header" />
          {!isPortrait && (
            <div className="col">
              {isSearchToggled && (
                <div
                  className="search-bar input-group input-group-m float-right"
                  onClick={this.setSearchVisibility}
                  style={{
                    maxWidth: t("searchPlaceHolder").length + 234,
                  }}
                >
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <SearchIcon className="search-icon" />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`${t("searchPlaceHolder")}`}
                    readOnly
                  />
                </div>
              )}
            </div>
          )}
          <div
            className={`${
              !isPortrait ? "col-auto col-side user-icons" : "col"
            }`}
          >
            {showMenu && (
              <span className="profile-icon-holder float-right">
                <UserProfileIcon
                  onClick={() => {
                    this.props.setMenuVisibility(this.props.showMenu);
                  }}
                  className={"profile-icon"}
                />
              </span>
            )}

            {page && balance && (
              <span className="currency-holder float-right">
                {currencyFormatter(balance, {
                  currency: this.props.currency,
                  symbol: this.props.symbol,
                  decimalplaces: this.props.decimalPlaces,
                })}
              </span>
            )}
            {isPortrait && isSearchToggled && (
              <span
                className="search-icon-holder float-right"
                onClick={this.setSearchVisibility}
              >
                <SearchIcon className="search-icon" />
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let page;
  let symbols;
  let showHeader;
  let showMenu;
  let displaySearch;
  let isFilterVisible;
  let showCashier;
  let showSwitchDevice;
  let showBanner;
  let allowMultiGamePlay;
  let isMobile = state.window.get("isMobile");
  let canToggleProviderLogoOnGames;
  let myQT;
  let webMainLobby;
  let categoryCount;
  let isSingleCategory;

  let { q } = queryString.parse(ownProps.location.search);

  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}
  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}

  try {
    allowMultiGamePlay = state.links.get("allowMultiGamePlay");
  } catch (err) {}

  try {
    let pageId = ownProps.match.params.page;
    if (pageId === "myQT") {
      page = state.pages.get("wl-pages").find((page) => {
        return page.get("rel") === pageId;
      });
      isFilterVisible = false;
    } else {
      let mainPage = state.pages.get("wl-pages").find((page) => {
        return page.get("rel") === "webLobbyMain";
      });
      page = mainPage.get("content").find((page) => {
        return page.get("rel") === pageId;
      });
      isFilterVisible = state.config.get("filtersVisible");
    }

    let exitLink = state.profile.get("links").find((link) => {
      return link.get("rel") === "exit";
    });

    let betHistoryLink = state.profile.get("links").find((link) => {
      return link.get("rel") === "service.url";
    });

    let gameRoundHistoryLink = state.profile.get("links").find((link) => {
      return link.get("rel") === "games-round-history.links";
    });

    let continuePlayingLink = state.profile.get("links").find((link) => {
      return link.get("rel") === "categories-home.recentlyplayed";
    });

    try {
      canToggleProviderLogoOnGames = state.profile.getIn([
        "uiControls",
        "canToggleProviderLogoOnGames",
      ]);
    } catch (err) {}

    if (!isEmpty(state.user.getIn(["symbol"]))) {
      let symbolList = state.user.getIn(["symbol"]);
      symbolList = symbolList.map((symbol) => {
        return String.fromCharCode(symbol);
      });
      symbols = symbolList.toJSON().join("");
    }

    try {
      myQT = state.pages.get("wl-pages").find((page) => {
        return page.get("rel") === "myQT";
      });
    } catch (err) {}

    try {
      webMainLobby = state.pages.get("wl-pages").find((page) => {
        return page.get("rel") === "webLobbyMain";
      });
    } catch (err) {}

    try {
      categoryCount = webMainLobby.getIn(["content"]).size;
    } catch (err) {}

    try {
      isSingleCategory = !myQT && categoryCount === 1;
    } catch (err) {}  

    showHeader =
      !isEmpty(state.user.get("displayName")) ||
      !isEmpty(state.user.get("balance")) ||
      state.user.get("showLanguage") ||
      exitLink ||
      betHistoryLink ||
      continuePlayingLink ||
      gameRoundHistoryLink ||
      showCashier ||
      showSwitchDevice ||
      (allowMultiGamePlay && isMobile);

    showMenu =
      !isEmpty(state.user.get("displayName")) ||
      state.user.get("showLanguage") ||
      exitLink ||
      betHistoryLink ||
      continuePlayingLink ||
      gameRoundHistoryLink ||
      showCashier ||
      showSwitchDevice ||
      allowMultiGamePlay ||
      canToggleProviderLogoOnGames;

    displaySearch = isEmpty(state.links.get("search"));
  } catch (err) {}
  try {
    showBanner = state.links.getIn(["showBanner"]);
  } catch (err) {}

  return {
    showBanner,
    showCashier,
    showSwitchDevice,
    showHeader,
    showMenu,
    displaySearch,
    page,
    displayName: state.user.get("displayName"),
    balance: state.user.get("balance"),
    currency: state.user.get("currency"),
    decimalPlaces: state.links.get("decimalPlaces"),
    symbol: symbols,
    isMobile,
    scrollY: state.window.getIn(["scroll", "y"]),
    filtersVisible: isFilterVisible,
    sessionId: state.security.get("sessionId"),
    showSearch: state.application.get("showSearch"),
    q: q,
    isSingleCategory,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    setMenuVisibility: (value) => dispatchProps.setMenuVisibility(value),
    setSearchVisibility: (value) => dispatchProps.setSearchVisibility(value),
    navigateTo: (path) => ownProps.history.push(path),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(Navigation));
